export const COUPON_STATUS = {
    STATUS_NEW: 1, // 未领取
    STATUS_RECEIVED: 2, // 已领取
    STATUS_FAILED: 3, // 领取失败
    STATUS_USED: 4, // 已使用
    STATUS_EXPIRED: 5, // 已过期(未使用)
    STATUS_LOCKED_NEW: 6, // 未领取(但是目前还不可领取,有些条件不满足,比如分享/签到)
    STATUS_RECEIVE_EXPIRED: 7, // 已过期(未领取)
};
export const COUPON_TYPE = {
    RED_BAG: 2, // 通用红包（多个商家可用的券）
    SHOP_COUPON: 1, // 商家券（仅单个商家可用的券）
};
export const COUPON_REMAIN_STATUS = {
    REMAIN_STATUS_DEFAULT: 0, // 默认填充值，没有任何意义
    REMAIN_STATUS_NEW: 1, // 存在未领取券
    REMAIN_STATUS_RECEIVED: 2, // 券已经被用户领取
    REMAIN_STATUS_NONE: 3, // 无任何券可以领取
};

export const ERROR_TEXT = '活动太火爆，券被抢光啦，一会再来试试吧';

export const PAGE_C_ID = 'c_waimai_kcgncd66';

export const COUPON_RECALL_TIME = {
    onPageLoad: 'onPageLoad',
    onTabClick: 'onTabClick',
};

export const WORD_CUP_TAB_BID = {
    FIFA2022YX: {
        mvBid: 'b_waimai_t32tsisb_mv',
        mcBid: 'b_waimai_t32tsisb_mc',
    },
    FIFA2022XC: {
        mvBid: 'b_waimai_b08rcj6w_mv',
        mcBid: 'b_waimai_b08rcj6w_mc',
    },
    FIFA2022NCYP: {
        mvBid: 'b_waimai_vz0yuqp1_mv',
        mcBid: 'b_waimai_vz0yuqp1_mc',
    },
    FIFA2022CSBL: {
        mvBid: 'b_waimai_fwx01d4m_mv',
        mcBid: 'b_waimai_fwx01d4m_mc',
    },
    FIFA2022JSXY: {
        mvBid: 'b_waimai_vj6ez6mt_mv',
        mcBid: 'b_waimai_vj6ez6mt_mc',
    },
};

export const TRAFFIC_EXPERIMENT_KEY = {
    couponTraffic: 'couponTraffic',
    initTraffic: 'initTraffic',
    allTraffic: 'allTraffic',
    noTraffic: 'noTraffic',
};
